import React from "react";
import Input from "@material-ui/core/Input";

function InputBox(props) {
  return <Input {...props} />;
}

export default InputBox;
